import axios from "axios";

const getAvailablePropertyTypes = async (personId, mlsIds) => {
  try {
    const url = `/people/${personId}/listing_alert_property_types.json?mls_ids=${mlsIds.join(",")}`;
    const { data } = await axios.get(url, createHeaders());

    return data.property_types;
  } catch (error) {
    console.error("Error fetching property types:", error);
    return [];
  }
};

const getAvailableFeatureFilters = async (personId, mlsIds) => {
  try {
    const url = `/people/${personId}/listing_alert_filter_options.json?mls_ids=${mlsIds.join(",")}`;
    const { data } = await axios.get(url, createHeaders());

    return data.filter_options;
  } catch (error) {
    console.error("Error fetching listing alert filter options:", error);
    return null;
  }
};

const getWebsiteDomain = async (personId) => {
  const url = `/people/${personId}/listing_alert_website_domain.json`;
  const { data } = await axios.get(url, createHeaders());

  return data.website_domain;
};

const getListingCounts = async (personId, alert) => {
  const url = `/people/${personId}/listing_alert_counts.json`;
  const { data } = await axios.post(url, alert, createHeaders());

  return data.total;
};

const getInstantAlertsEnabled = async (personId) => {
  try {
    const url = `/people/${personId}/listing_alerts/instant_alerts_enabled.json`;
    const { data } = await axios.get(url);

    return data.instant_alerts_enabled;
  } catch (error) {
    console.error("Error fetching instant alerts enabled:", error);
    return false;
  }
};

const getQueryStringForIdx = async (personId, alert) => {
  const url = `/people/${personId}/listing_alert_search_query.json`;
  const { data } = await axios.post(url, alert, createHeaders());

  return data.search_query;
};

const getAlerts = async (personSlug, { includeMlsIds = false } = {}) => {
  const url = `/people/${personSlug}/listing_alerts`;
  const config = createHeaders();
  if (includeMlsIds) {
    config.params = { include_mls_ids: true };
  }
  return axios.get(url, config);
};

const createAlert = async (personId, alert) => {
  const url = `/people/${personId}/listing_alerts`;
  return axios.post(url, alert, createHeaders());
};

const updateAlert = async (personId, alertId, alert) => {
  const url = `/people/${personId}/listing_alerts/${alertId}`;
  return axios.patch(url, alert, createHeaders());
};

const getTemplates = async (personId) => {
  try {
    const url = `/listing_alert_templates`;
    const { data } = await axios.get(url, createHeaders());

    return data || [];
  } catch (error) {
    console.error("Error fetching listing alert templates:", error);
    return [];
  }
};

export {
  getAvailablePropertyTypes,
  getAvailableFeatureFilters,
  getWebsiteDomain,
  getListingCounts,
  getInstantAlertsEnabled,
  getQueryStringForIdx,
  getAlerts,
  createAlert,
  updateAlert,
  getTemplates,
};

const createHeaders = () => {
  return {
    headers: {
      "X-CSRF-Token": ReactOnRails.authenticityToken(),
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
};
